import * as React from 'react'

import Svg, { ClipPath, Defs, G, Path } from 'react-native-svg'

function LockOutLined(props) {
  return (
    <Svg
      width={24}
      height={25}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <G clipPath="url(#clip0_2586_6788)" fill="#231F20">
        <Path d="M17.12 9.262v-2.38c0-2.14-2.04-3.89-4.56-3.89h-1.13c-2.51 0-4.56 1.74-4.56 3.89v2.39c-1.58.3-2.77 1.68-2.77 3.34v6.82c0 1.88 1.53 3.41 3.41 3.41h9.07c1.88 0 3.41-1.53 3.41-3.41v-6.82c0-1.7-1.25-3.1-2.88-3.36l.01.01zm-8.54-2.38c0-1.19 1.31-2.19 2.86-2.19h1.13c1.55 0 2.86 1 2.86 2.19v2.33H8.59v-2.33h-.01zm9.72 12.55c0 .94-.77 1.71-1.71 1.71H7.52c-.94 0-1.71-.77-1.71-1.71v-6.82c0-.94.77-1.71 1.71-1.71h9.07c.94 0 1.71.77 1.71 1.71v6.82z" />
        <Path d="M11.86 13.842c-.98 0-1.78.8-1.78 1.78 0 .67.38 1.25.92 1.55v1.55c0 .31.25.56.56.56h.6c.31 0 .56-.25.56-.56v-1.55c.55-.3.92-.88.92-1.55 0-.98-.8-1.78-1.78-1.78z" />
      </G>
      <Defs>
        <ClipPath id="clip0_2586_6788">
          <Path fill="#fff" transform="translate(0 .842)" d="M0 0H24V24H0z" />
        </ClipPath>
      </Defs>
    </Svg>
  )
}

export default LockOutLined
